import { httpClient } from './http-client';
import type {
  BaseStoredPaymentMethod,
  BlockAmountDto,
  ChargeAmountDto,
  ChargeAmountResponseDto,
  CreditWithRefundDto,
  CreditWithRefundResponseDto,
  PromoteStoredPaymentMethodDto,
  StoreIbanPaymentMethodDto,
  StorePaymentMethodDto,
} from '@carvia/ros-client-types';

class PaymentApiService {
  httpClient = httpClient;
  endpoint = '/payment-api';

  async chargeAmount(data: ChargeAmountDto) {
    const res = await this.httpClient.post<ChargeAmountResponseDto>(
      `${this.endpoint}/charge-amount`,
      data,
    );
    return res.data;
  }

  async creditWithRefund(data: CreditWithRefundDto) {
    const res = await this.httpClient.post<CreditWithRefundResponseDto>(
      `${this.endpoint}/credit-with-refund`,
      data,
    );
    return res.data;
  }

  async blockAmount(data: BlockAmountDto) {
    const res = await this.httpClient.post<ChargeAmountResponseDto>(
      `${this.endpoint}/block-amount`,
      data,
    );
    return res.data;
  }

  async storePaymentMethod(data: StorePaymentMethodDto) {
    const res = await this.httpClient.post<ChargeAmountResponseDto>(
      `${this.endpoint}/store-payment-method`,
      data,
    );
    return res.data;
  }

  async promoteStoredPaymentMethodToPeriodicCharge(data: PromoteStoredPaymentMethodDto) {
    const res = await this.httpClient.post<BaseStoredPaymentMethod[]>(
      `${this.endpoint}/stored-payment-methods/promote-periodic-charge`,
      data,
    );
    return res.data;
  }

  async storeIbanPaymentMethod(data: StoreIbanPaymentMethodDto) {
    const res = await this.httpClient.post<BaseStoredPaymentMethod[]>(
      `${this.endpoint}/stored-payment-methods/iban`,
      data,
    );
    return res.data;
  }

  async getStoredPaymentMethods(bookingId: string) {
    const res = await this.httpClient.get<BaseStoredPaymentMethod[]>(
      `${this.endpoint}/stored-payment-methods`,
      {
        params: {
          bookingId,
        },
      },
    );
    return res.data;
  }
}

export const paymentApiService = new PaymentApiService();
